/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Read/Info/HelpTooltip/Content"
  
}) {
  let isBefore = useIsBefore()
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsOrange700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.700'
        })
let appointmentNoteSysCreatedValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_note',
path: 'sys_created',
format: fromHelpers.getCreatedAt,
})
let appointmentNoteAuthorUserPersonValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_note',
path: 'author_user.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1Yf8zk': dtColorsNeutral700,'--bblr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-10-Z1Yf8zk': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="This note is editable"
 color={dtColorsWhite}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="until 24 hours"
 color={dtColorsOrange700}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="bold"
 text="after"
 color={dtColorsWhite}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="the appointment"
 color={dtColorsWhite}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="Created"
 color={dtColorsWhite}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 data="appointment_note.sys_created"
 format="helpers.js getCreatedAt"
 text={appointmentNoteSysCreatedValueData}
 color={dtColorsWhite}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="by"
 color={dtColorsWhite}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="bold"
 data="appointment_note.author_user.person"
 format="/Data/format.js personName"
 text={appointmentNoteAuthorUserPersonValueData}
 color={dtColorsWhite}
/>
</div>
</div>
{children}
</React.Fragment>)
}